import React, { useEffect, useState } from "react";
import "./Infocustomer.css";

const ITEMS_PER_PAGE = 30;

const Infocustomer = () => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [showDeactivateConfirm, setShowDeactivateConfirm] = useState(false);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [deactivateMessage, setDeactivateMessage] = useState("");
  const [deactivateMessageType, setDeactivateMessageType] = useState("");
  const [isDeactivating, setIsDeactivating] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [data]);

  const fetchData = () => {
    fetch("/customer", {
      credentials: "include",
    })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((json) => {
        setData(Array.isArray(json) ? json : []);
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
        setData([]);
      });
  };

  const deactivateCustomer = (id) => {
    setSelectedCustomerId(id);
    setDeactivateMessage("");
    setDeactivateMessageType("");
    setShowDeactivateConfirm(true);
  };

  const confirmDeactivateCustomer = async () => {
    if (!selectedCustomerId) return;

    setIsDeactivating(true);
    setDeactivateMessage("");
    setDeactivateMessageType("");

    try {
      const res = await fetch(
        `/customer/${selectedCustomerId}/deactivate`,
        {
          method: "PATCH",
          credentials: "include",
        },
      );

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(data?.error || "Deactivate failed");
      }

      setShowDeactivateConfirm(false);
      setSelectedCustomerId(null);

      setDeactivateMessage("Customer has been deactivated.");
      setDeactivateMessageType("success");

      fetchData();

      setTimeout(() => {
        setDeactivateMessage("");
        setDeactivateMessageType("");
      }, 3000);
    } catch (err) {
      console.error("Deactivate failed:", err);

      setDeactivateMessage(err.message || "Failed to deactivate customer.");
      setDeactivateMessageType("error");
    } finally {
      setIsDeactivating(false);
    }
  };

  const cancelDeactivateCustomer = () => {
    setShowDeactivateConfirm(false);
    setSelectedCustomerId(null);
    setDeactivateMessage("");
    setDeactivateMessageType("");
  };

  const totalPages = Math.ceil(data.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const paginatedData = data.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  return (
    <div className="infocustomer-container">
      <h1 className="cus-info-title">Customer Information</h1>

      <div className="infocustomer-table-frame">
        <table className="infocustomer-table">
          <thead>
            <tr>
              <th>Email</th>
              <th>Name</th>
              <th>Company</th>
              <th>Position</th>
              <th>Phone</th>
              <th>Address</th>
              <th>Timezone</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {Array.isArray(paginatedData) && paginatedData.length > 0 ? (
              paginatedData.map((item) => (
                <tr
                  key={item.id}
                  className={item.is_active === 0 ? "inactive-row" : ""}
                >
                  <td>{item.email}</td>
                  <td>{item.name}</td>
                  <td>{item.CompanyName}</td>
                  <td>{item.position}</td>
                  <td>{item.phone}</td>
                  <td>{item.address}</td>
                  <td>{item.timezone_offset}</td>
                  <td>
                    <button
                      className="infocustomer-delete-button"
                      disabled={item.is_active === 0}
                      onClick={() => {
                        if (item.is_active === 1) deactivateCustomer(item.id);
                      }}
                    >
                      {item.is_active === 1 ? "Deactivate" : "Disabled"}
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8">No data available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="ticket-pagination">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            Previous
          </button>

          {Array.from({ length: totalPages }, (_, index) => {
            const page = index + 1;

            return (
              <button
                key={page}
                onClick={() => setCurrentPage(page)}
                className={currentPage === page ? "active-page" : ""}
              >
                {page}
              </button>
            );
          })}

          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      )}
      {showDeactivateConfirm && (
        <div className="customer-modal-overlay">
          <div className="customer-confirm-modal">
            <h3>ยืนยันการปิดใช้งาน</h3>

            <p>ต้องการปิดการใช้งานลูกค้ารายนี้ใช่หรือไม่?</p>

            {deactivateMessage && (
              <div
                className={`customer-popup-message ${deactivateMessageType}`}
              >
                {deactivateMessage}
              </div>
            )}

            <div className="customer-confirm-actions">
              <button
                type="button"
                className="customer-confirm-danger-btn"
                onClick={confirmDeactivateCustomer}
                disabled={isDeactivating}
              >
                {isDeactivating ? "กำลังดำเนินการ..." : "ยืนยัน"}
              </button>

              <button
                type="button"
                className="customer-confirm-cancel-btn"
                onClick={cancelDeactivateCustomer}
                disabled={isDeactivating}
              >
                ยกเลิก
              </button>
            </div>
          </div>
        </div>
      )}

      {deactivateMessage && !showDeactivateConfirm && (
        <div className="customer-toast-wrapper">
          <div className={`customer-toast-message ${deactivateMessageType}`}>
            {deactivateMessage}
          </div>
        </div>
      )}
    </div>
  );
};

export default Infocustomer;
